import { h } from 'preact';
import React from 'react';

import { ColumnSettings } from './ColumnSettings';
import Children from '../../messages/Notice/Children';
import { useDev } from '../../hooks';

import './Column.css';

export const Column = (props) => {
  let {
    component,
    path,
    dev,
    className,
    siteId,
    message,
    makeChoice,
    language,
    events,
    preloadMsg,
    stacksData,
    updateStacks,
    consentUUID,
    allSelectionsMade,
    shown,
    setVendorCount,
    vendorCount
  } = props
  
  const settings = new ColumnSettings(component.settings);
  let { devActions, devClass, pathString } = useDev(path, dev);

  const styles = {
    ...settings.padding,
    ...settings.margin,
    ...settings.border
  };

  if (dev) {
    if (component.children.length === 0) {
      styles.minHeight = '24px';
    };
    if (!dev.opts.hideRowColumnBorders) {
      devClass += ' on-dev';
    };
  };

  /* WIDTH & HEIGHT */
  const { paddingTop, paddingBottom } = settings.padding;
  const { marginTop, marginBottom } = settings.margin;
  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  styles.height = settings.height.type === 'auto' ? 'auto' : settings.height.value + settings.height.type;
  if (settings.height.type === '%') {
    styles.height = `calc(${settings.height.value}% - ${(paddingTop + paddingBottom + marginTop + marginBottom)}px`;
  };

  /* OTHER settings */
  styles.background = settings.background;
  styles.alignItems = settings.align;
  styles.justifyContent = settings.vertical;

  return (
    <div
      style={styles}
      className={'message-component message-column' + devClass + className}
      path={dev ? pathString : null}
      {...devActions}
    >
      <Children
        {...props}
        path={path}
        dev={dev}
        components={component.children}
        siteId={siteId}
        message={message}
        makeChoice={makeChoice}
        language={language}
        events={events}
        preloadMsg={preloadMsg}
        stacksData={stacksData}
        updateStacks={updateStacks}
        consentUUID={consentUUID}
        width={null}
        allSelectionsMade={allSelectionsMade}
        shown={shown}
        setVendorCount={setVendorCount}
        vendorCount={vendorCount}
      />
    </div>
  );
};